export default "__VITE_ASSET__DaN_gCS9__"